var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04569 6.24968C4.32229 4.38265 5.92487 3 7.81228 3H16.1877C18.0751 3 19.6777 4.38265 19.9543 6.24968L20.8692 12.4252C20.9563 13.013 21 13.6064 21 14.2007V16.5C21 18.9853 18.9853 21 16.5 21H7.5C5.01472 21 3 18.9853 3 16.5V14.2007C3 13.6064 3.04372 13.013 3.1308 12.4252L4.04569 6.24968ZM7.81228 5.07692C6.95436 5.07692 6.22592 5.7054 6.10019 6.55405L5.29339 12H8.73178C9.47676 12 10.1382 12.4767 10.3737 13.1835L10.5927 13.8402C10.6398 13.9816 10.7721 14.0769 10.9211 14.0769H13.0789C13.2279 14.0769 13.3602 13.9816 13.4073 13.8402L13.6263 13.1835C13.8618 12.4767 14.5232 12 15.2682 12H18.7066L17.8998 6.55405C17.7741 5.7054 17.0456 5.07692 16.1877 5.07692H7.81228Z",
    fill: "#798797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.85e9931396d7d53cc978e426e35db7e7.svg";
export { ForwardRef as ReactComponent };